import template from './_table.pug'
import FullTable from 'js/components/full-table/index.js'
import { openModalConfirmRemove } from 'js/services/modals.js'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    callStatusMappings: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFilters: true, 
      
      // Variables para el modal de carga
      showUploadModal: false,
      selectedFile: null,
      isUploading: false,

      filters: {
        typology: '',
        typologyMapping: '',
        level2: null,
        status: null
      },
      level2Options: [
        { id: 'GESTIONABLES', value: 'GESTIONABLES', text: 'GESTIONABLES', label: 'GESTIONABLES', name: 'GESTIONABLES' },
        { id: 'NO GESTIONABLES', value: 'NO GESTIONABLES', text: 'NO GESTIONABLES', label: 'NO GESTIONABLES', name: 'NO GESTIONABLES' },
        { id: 'SIN TIPIFICAR', value: 'SIN TIPIFICAR', text: 'SIN TIPIFICAR', label: 'SIN TIPIFICAR', name: 'SIN TIPIFICAR' }
      ],
      statusOptions: [
        { id: 'CONTACTADO', value: 'CONTACTADO', text: 'CONTACTADO', label: 'CONTACTADO', name: 'CONTACTADO' },
        { id: 'NO CONTACTADO', value: 'NO CONTACTADO', text: 'NO CONTACTADO', label: 'NO CONTACTADO', name: 'NO CONTACTADO' }
      ]
    }
  },

  computed: {
    filterButtonParams() {
      if (this.showFilters) {
        return { class: 'active', icon: 'angle-up' }
      }
      return { class: '', icon: 'angle-down' }
    }
  },
  methods: {
    getData(queryOptions = {}) {
      const activeFilters = queryOptions.filter || this.filters;

      let params = {
        'page[number]': queryOptions.page ? queryOptions.page.number : 1,
        'page[size]': queryOptions.page ? queryOptions.page.size : 20
      };
      
      if (queryOptions.filter && Object.keys(queryOptions.filter).length === 0) {
        this.filters.typology = '';
        this.filters.typologyMapping = '';
        this.filters.level2 = null;
        this.filters.status = null;
      }

      if (activeFilters.typology) params['filter[typology]'] = activeFilters.typology;
      if (activeFilters.typologyMapping) params['filter[typologyMapping]'] = activeFilters.typologyMapping;
      if (activeFilters.level2) params['filter[level2]'] = activeFilters.level2;
      if (activeFilters.status) params['filter[status]'] = activeFilters.status;

      if (queryOptions.order && Object.keys(queryOptions.order).length > 0) {
        params['sort'] = queryOptions.order; 
      }

      this.$emit('load-data', params);
    },

    openConfirmModal(mapping) {
      openModalConfirmRemove(
        'Eliminar codificación',
        `¿Estás seguro de que deseas eliminar la tipología "${mapping.typology}"?`,
        'Eliminar'
      ).then(() => this.destroy(mapping))
    },

    destroy(mapping) {
      API.callStatusMappings.destroy(mapping.id).then(() => {
        this.getData();
        this.$notifications.success('Tipología eliminada correctamente');
      }).catch(error => {
        console.error("Error al eliminar tipología:", error);
        this.$notifications.error('Hubo un error al intentar eliminar la tipología');
      });
    },

    // Lógica del Modal de Carga de Ficheros
    openUploadModal() {
      this.selectedFile = null;
      this.showUploadModal = true;
    },
    
    closeModal() {
      this.showUploadModal = false;
      this.selectedFile = null;
    },
    
    onFileSelected(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.selectedFile = event.target.files[0];
      }
    },
    
    uploadFile() {
      if (!this.selectedFile) return;
      this.isUploading = true;

      API.callStatusMappings.uploadFile(this.selectedFile).then(() => {
        this.$notifications.success('Fichero cargado y codificaciones actualizadas correctamente');
        this.closeModal();
        this.getData(); 
      }).catch(error => {
        console.error("Error cargando fichero: ", error);
        this.$notifications.error('Ocurrió un error al intentar subir el fichero');
      }).finally(() => {
        this.isUploading = false;
      });
    }
  }
})